// 订单清单专用显示元数据；不更改记录、业务插槽、筛选和操作事件。
import type { AdaptiveColumn } from './responsiveTable'
export const orderField=(column:AdaptiveColumn)=>Array.isArray(column.dataIndex)?column.dataIndex.join('.'):String(column.dataIndex || column.key || '')
export function orderCellClass(column:AdaptiveColumn):string {
 const key=orderField(column)
 if(/^(commands?|subcommand|operate|operations?|actions?|refound|delete|view)$/i.test(key))return 'order-fit-action'
 if(/(time|date|expiredAt|createdAt|updatedAt)$/i.test(key))return 'order-fit-time'
 if(/(price|amount|balance|fee|money|total|status|state)$/i.test(key))return 'order-fit-critical'
 return 'order-fit-flex'
}
export function orderFitColumns<T extends AdaptiveColumn>(columns:T[],rows:any[],measured:Record<string,number>={}):T[] {
 return columns.filter(column=>{
  // 只去除记录明确没有评分的列；下载等业务插槽不能根据缺少同名字段误删。
  if(!['score','rating'].includes(orderField(column)) || !rows.length)return true
  return rows.some(row=>Number(row[orderField(column)])>0)
 }).map(column=>{
  if(column.children?.length)return {...column,children:orderFitColumns(column.children,rows)} as T
  const key=orderField(column),kind=orderCellClass(column)
  const explicit=Number(column.width)||0
  let preferred=92,floor=26,flex=1
  if(kind==='order-fit-action')return {...column,orderFit:true,fitFloor:Number(column.minWidth)||explicit||80,className:[(column as any).className,kind].filter(Boolean).join(' ')} as T
  if(kind==='order-fit-time'){preferred=132;floor=122;flex=0}
  else if(kind==='order-fit-critical'){preferred=/(status|state)$/i.test(key)?86:82;floor=/(status|state)$/i.test(key)?74:74;flex=0}
  else if(/^(orderNumber|orderId|requestNumber|demandNumber)$/i.test(key)){preferred=88;floor=82;flex=0}
  else if(/(image|picture|thumbnail|img)/i.test(key)){preferred=40;floor=34;flex=0}
  else if(/^(download|attachment|attachments)$/i.test(key)){preferred=36;floor=30;flex=0}
  else if(/(phone|mobile|tel)/i.test(key)){preferred=108;floor=34}
  else if(/(title|productName|description|remark|content|orderInfo)/i.test(key)){preferred=150;floor=32;flex=3}
  else if(/(name|code|number|No)$/i.test(key)){preferred=100;floor=28}
  else if(/(count|quantity|sales|rate|size|type|source)/i.test(key)){preferred=66;floor=24}
  if(kind==='order-fit-critical' || kind==='order-fit-time'){floor=Math.max(floor,measured[key] || 0);preferred=Math.max(preferred,floor)}
  const cell=(column as any).customCell
  return {...column,customCell:(record:any,index:number)=>({...cell?.(record,index),'data-order-fit-key':key}),fixed:undefined,minWidth:preferred,maxWidth:undefined,flex,orderFit:true,fitFloor:floor,
    className:[(column as any).className,kind].filter(Boolean).join(' ')} as T
 })
}
